import React, { useState } from 'react';
import { ModelBuilderProvider } from '~/components/FormulasTable';
import Header from '~/components/Header';
import Legend from './Components/Legend';
import EllipsisDropdown from '~/components/EllipsisDropdown';
import Modal from '~/components/Modal';
import ManageGroups from './Components/ManageGroups';
import UserDateRange from '~/components/UserDateRange';
import FinancialModelTable from './Components/FinancialModelTable';

const FinancialModelPage = (): React.ReactElement => {
  const [manageGroupsModalOpen, setManageGroupsModalOpen] = useState(false);

  return (
    <ModelBuilderProvider>
      <div className="w-full bg-neutral-15 h-screen">
        <Header
          title="Financial Model"
          startChildren={<Legend />}
          endChildren={
            <div className="flex items-center">
              <div className="flex w-full justify-end items-center gap-2">
                <UserDateRange pickerAlignment="right" />
              </div>
              <EllipsisDropdown
                options={[
                  {
                    label: 'Manage Groups',
                    onClick: () => setManageGroupsModalOpen(true),
                  },
                ]}
              />
            </div>
          }
        />

        <FinancialModelTable />

        <Modal
          isOpen={manageGroupsModalOpen}
          onClose={() => setManageGroupsModalOpen(false)}
          title="Edit Groups"
          size="xxs"
        >
          <ManageGroups onClose={() => setManageGroupsModalOpen(false)} />
        </Modal>
      </div>
    </ModelBuilderProvider>
  );
};

export default FinancialModelPage;
